<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">Información de contrato número: {{ data.number }}</h5>
          <h6 class="card-subtitle mb-2 text-muted">{{data.name}}</h6>
          <h6 class="card-subtitle mb-2 text-muted">{{data.status}}</h6>
          <div class="card mt-5">
            <div class="card-header">
              Informacion Basica
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-2">
                  <h6>Evento</h6>
                </div>
                <div class="col-md-2">
                  <h6>Salón</h6>
                </div>
                <div class="col-md-2">
                  <h6>Fecha</h6>
                </div>
                <div class="col-md-2">
                  <h6>Saldo Inicial</h6>
                </div>
                <div class="col-md-2">
                  <h6>Saldo Actual</h6>
                </div>
                <div class="col-md-2">
                  <h6>Vendedor</h6>
                </div>
              </div>
              <div class="row">
                <div class="col-md-2">{{ data.type }}</div>
                <div class="col-md-2">{{ data.salon }}</div>
                <div class="col-md-2">{{ data.date }}</div>
                <div class="col-md-2">$ {{ data.si }}</div>
                <div class="col-md-2">$ {{ data.sa }}</div>
                <div class="col-md-2">{{ data.vendedor }}</div>
              </div>
            </div>
          </div>

          <div class="card mt-3">
            <div class="card-header">
              Estado de cuenta
            </div>
            <div class="card-body">
              <div class="row text-center">
                <div class="col-md-4">
                  <h6>Comensales</h6>
                </div>
                <div class="col-md-4">
                  <h6>Total de Abonos</h6>
                </div>
                <div class="col-md-4">
                  <h6>Total de Cargos</h6>
                </div>
              </div>
              <div class="row text-center">
                <div class="col-md-4">{{ data.comensales }} <br /><a href="#" @click="showDetails('comensales')">ver más</a ></div>
                <div class="col-md-4">$ {{ data.abonos }} <br /><a href="#" @click="showDetails('abonos')">ver más</a ></div>
                <div class="col-md-4">$ {{ data.cargos }} <br /><a href="#" @click="showDetails('cargos')">ver más</a ></div>
              </div>
            </div>
          </div>

          <div class="card mt-3">
            <div class="card-header">
              Acciones rapidas
            </div>
            <div class="card-body">
               <button class="btn btn-purple mr-4" @click="setAbono()">Realizar Abono</button>
               <button class="btn btn-purple mr-4" @click="setAbono()">Realizar Cargo</button>
            </div>
          </div>
          <div class="card mt-3">
            <div class="card-header">
              Servicios
            </div>
          </div>
          <div class="card mt-3">
            <div class="card-header">
              Otros
            </div>
          </div>
          <div class="card mt-3">
            <div class="card-header">
              Comentarios - Observaciones
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal name="details" :adaptive="true" :scrollable="true" height="400" class="">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('details')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="text-center reset-pass" @click="$modal.hide('details')">
        <h2>{{titleModal}}</h2>
        <div v-if="showComensales">
          <div class="row mt-5">
            <div class="col-lg-3">Adultos</div>
            <div class="col-lg-3">Jovenes</div>
            <div class="col-lg-3">Niños</div>
            <div class="col-lg-3">Total</div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-3">{{comensales.adultos}}</div>
            <div class="col-lg-3">{{comensales.jovenes}}</div>
            <div class="col-lg-3">{{comensales.ninos}}</div>
            <div class="col-lg-3">{{comensales.total}}</div>
          </div>
        </div>
        <div v-if="showAbonos" style="overflow: scroll;">
          <div class="row mt-5">
            <div class="col-lg-3">Fecha</div>
            <div class="col-lg-3">Efectuo</div>
            <div class="col-lg-3">Importe</div>
            <div class="col-lg-3">Concepto</div>
          </div>
          <div class="row mt-3" v-for="(abono, index) in abonos" :key="index">
            <div class="col-lg-3">{{abono.fecha}}</div>
            <div class="col-lg-3">{{abono.recibide}}</div>
            <div class="col-lg-3">{{abono.importe}}</div>
            <div class="col-lg-3">{{abono.concepto}}</div>
          </div>
        </div>
        <div v-if="showCargos" style="overflow: scroll;">
          <div class="row mt-5">
            <div class="col-lg-3">Fecha</div>
            <div class="col-lg-3">Tipo</div>
            <div class="col-lg-3">Importe</div>
            <div class="col-lg-3">Concepto</div>
          </div>
          <div class="row mt-3" v-for="(cargo, index) in cargos" :key="index">
            <div class="col-lg-3">{{cargo.fecha}}</div>
            <div class="col-lg-3">{{cargo.tipo}}</div>
            <div class="col-lg-3">{{cargo.importe}}</div>
            <div class="col-lg-3">{{cargo.concepto}}</div>
          </div>
        </div>
      </div>
    </modal>
    <modal name="setAbono" :adaptive="true" :scrollable="true" height="550" class="">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('setAbono')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="text-center reset-pass">
        <h2>Nuevo abono</h2>
        <div class="mt-3 col-lg-12">
          <div class="form-group">
            <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Recibi de" v-model="sendAbono.name">
            <small id="emailHelp" class="form-text text-muted">Nombre de la persona que esta efectuando un abono</small>
          </div>
          <div class="form-group">
            <select class="form-control form-control-lg" v-model="sendAbono.concepto">
              <option>Seleccione un tipo de pago</option>
              <option>Cheque</option>
              <option>Efectivo</option>
              <option>Tarjeta</option>
              <option>Transferencia</option>
              <option>Deposito</option>
            </select>
          </div>
          <div class="form-group">
            <select class="form-control form-control-lg" v-model="sendAbono.cuenta">
              <option v-for="(option, index) in optionsAcount" :key="index" v-bind:value="option.value">
                {{ option.text }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <input type="number" class="form-control" id="amount" v-model="sendAbono.amount" aria-describedby="emailHelp" placeholder="Cantidad del abono">
            <small id="emailHelp" class="form-text text-muted">Cantidad total por abonar</small>
          </div>
          <button class="btn btn-primary" @click="saveAbono">Guardar</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'

export default {
  mixins: [formatData],
  data () {
    return {
      sendAbono: {
        name: '',
        amount: 0,
        cuenta: '0',
        concepto: 'Seleccione un tipo de pago'
      },
      optionsAcount: [
        { text: 'Seleccione una cuenta a afectar', value: '0' },
        { text: 'EFECTIVO', value: '2' },
        { text: 'IXE EVENTOS', value: '7' },
        { text: 'IXE SMB', value: '8' },
        { text: 'BANAMEX SMB', value: '9' },
        { text: 'SAUL MORAN', value: '10' },
        { text: 'BANAMEX EVENTOS', value: '11' }
      ],
      showComensales: false,
      showAbonos: false,
      showCargos: false,
      comensales: [],
      cargos: [],
      abonos: [],
      data: [],
      contrato: '',
      user: null,
      titleModal: ''
    }
  },
  methods: {
    showDetails (type) {
      this.$modal.show('details')
      switch (type) {
        case 'comensales':
          this.titleModal = 'Comensales'
          this.showComensales = true
          this.showAbonos = false
          this.showCargos = false
          break
        case 'abonos':
          this.titleModal = 'Abonos'
          this.showAbonos = true
          this.showCargos = false
          this.showComensales = false
          break
        case 'cargos':
          this.titleModal = 'Cargos'
          this.showAbonos = false
          this.showCargos = true
          this.showComensales = false
          break
        default:
          break
      }
    },
    async getAbonos () {
      try {
        const requestAbonos = {
          function: 'getAbonos',
          contrato: this.data.number
        }
        const params = await this.toFormData(requestAbonos)
        const abonos = await axiosAdelaService.post('/', params)
        console.log('abonnos', abonos)
        if (abonos.status === 200) {
          this.abonos = abonos.data
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async getCargos () {
      try {
        const requestCargos = {
          function: 'getCargos',
          contrato: this.data.number
        }
        const params = await this.toFormData(requestCargos)
        const cargos = await axiosAdelaService.post('/', params)
        if (cargos.status === 200) {
          this.cargos = cargos.data
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async getComensales () {
      try {
        const requestComensales = {
          function: 'getComensales',
          contrato: this.data.number
        }
        const params = await this.toFormData(requestComensales)
        const comensales = await axiosAdelaService.post('/', params)
        if (comensales.status === 200) {
          this.comensales = comensales.data
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    setAbono () {
      this.$modal.show('setAbono')
    },
    async saveAbono () {
      console.log(this.sendAbono.name)
      const requestComensales = {
        function: 'setAbono',
        contrato: this.data.number,
        nombre: this.data.name,
        cantidad: this.sendAbono.amount,
        recibide: this.sendAbono.name,
        concepto: this.sendAbono.concepto,
        tipoevento: this.data.type,
        salon: this.data.salon,
        fechaevento: this.data.date,
        cuenta: this.sendAbono.cuenta
      }
      console.log(this.data, requestComensales)
      const params = await this.toFormData(requestComensales)
      const save = await axiosAdelaService.post('/', params)
      console.log(save)
      if (save.status === 200) {
        let err = false
        if (save.data.InsertAbonno) {
          this.$toastedPush({
            message: 'Abono insertado satisfactoriamente',
            type: 'success'
          })
        } else {
          this.showError('No se pudo realizar el registro del abono, por favor contacte a su equipo de soporte.')
          err = true
        }
        if (save.data.InsertMovimientoCuenta) {
          this.$toastedPush({
            message: 'Se registro el movimiento a las cuentas satisfactoriamente',
            type: 'success'
          })
        } else {
          this.showError('No se pudo registrar el movimiento a cuentas, por favor contacte a su equipo de soporte.')
        }
        if (save.data.updateBanco) {
          this.$toastedPush({
            message: 'Se actualizo el saldo en el banco correctamente',
            type: 'success'
          })
        } else {
          this.showError('No se pudo actualizar el saldo al banco.')
        }
        if (!err) {
          window.open('https://qroodigo.com.mx/TesteoVillaConin/PDFEspecial/Abonos/last.php?id=' + save.data.abono, '_blank')
        }
      }
    }
  },
  watch: {
  },
  async mounted () {
    try {
      this.data = this.$route.params.row
      await this.getComensales()
      await this.getCargos()
      await this.getAbonos()
    } catch (error) {
      this.showError('No se pudieron obtener los datos intentalo mas tarde.')
    }
  },
  created () {
    this.user = this.$_.get(this.$route, 'params.row', {})
    this.user.created_at = DateTime.fromISO(this.user.created_at, { zone: 'America/Mexico_City' }).toFormat('dd LLL yyyy')
  }
}
</script>

<style>
</style>
